import { render, staticRenderFns } from "./RichTextAreaHelp.vue?vue&type=template&id=705478b2&scoped=true"
import script from "./RichTextAreaHelp.vue?vue&type=script&lang=js"
export * from "./RichTextAreaHelp.vue?vue&type=script&lang=js"
import style0 from "./RichTextAreaHelp.vue?vue&type=style&index=0&id=705478b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705478b2",
  null
  
)

export default component.exports